/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PAY_TXS = gql`
  query GetPayTxs($filters: PayTxFilterInput, $options: GetManyOptions) {
    getPayTxs(filters: $filters, options: $options) {
      count
      limit
      skip
      sort {
        field
        order
      }
      content {
        presentation {
          id
          name
        }
        amount
        masqUser {
          vuid
        }
        costumeID
        createdAt
        updatedAt
        mode
        notes
        txId
        status
        reciptId
        payOrder {
          box {
            id
            costumeID
          }
          id
        }
        id
        handler
        currency
        resolutionStatus
        payMethod
        actualPayment {
          amount
          currency
        }
      }
    }
  }
`;

export const GET_PAY_TXS_ADMIN = gql`
  query GetPayTxs($filters: PayTxFilterInput, $options: GetManyOptions) {
    getPayTxs(filters: $filters, options: $options) {
      count
      limit
      skip
      sort {
        field
        order
      }
      content {
        presentation {
          id
          name
        }
        amount
        costumeID
        masqUser {
          firstName
          email
          fullName
          id
          vuid
        }
        createdAt
        updatedAt
        createdByUser {
          email
          emailVerified
          id
          fullName
        }
        mode
        notes
        txId
        status
        reciptId
        payOrder {
          box {
            id
            costumeID
          }
          id
        }
        id
        handler
        currency
        resolutionStatus
        payMethod
        actualPayment {
          amount
          currency
        }
      }
    }
  }
`;
